import { render } from "./RecentActivity.vue?vue&type=template&id=745ba222"
import script from "./RecentActivity.vue?vue&type=script&lang=js"
export * from "./RecentActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__